export const KBA_UNAVAILABLE_ERROR_KEY = 'esl.error.validation.knowledgeBasedAuthentication.notAvailableForSpecifiedUser';
export const ACCESS_LOCKED_ERROR_KEY = 'esl.error.unauthorised.lockedTooManyAttempts';
export const ACCESS_LOCKED_WITH_MINUTES_ERROR_KEY = 'esl.error.forbidden.knowledgeBasedAuthentication.lockedTooManyAttemptsWithMinutes';
export const ACCESS_LOCKED_WITH_HOURS_MINUTES_ERROR_KEY = 'esl.error.forbidden.knowledgeBasedAuthentication.lockedTooManyAttemptsWithHoursMinutes';
export const ACCESS_LOCKED_TITLE_KEY = 'esl.error.unauthorised.lockedTooManyAttempts.title';
export const SESSION_EXPIRED_KEY = 'esl.error.unauthorised.sessionExpired';
export const SESSION_EXPIRED_TITLE_KEY = 'esl.error.unauthorised.sessionExpiredTitle';
export const UNHANDLED_SERVER_ERROR = 'esl.http.status_500';
export const ACCESS_DENIED_TITLE_KEY = 'esl.http.status_403';
